var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clock-ring-chart",style:({ width: _vm.size + 'px', height: _vm.size + 'px', position: 'relative' })},[_c('canvas',{ref:"canvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }